import { ReactNode } from 'react';

import { Text, Colors } from '@rockalingua/ui';

import { Container, Header } from './ExpiredSubscriptionContainer.styled';

type ExpiredSubscriptionContainerProps = {
  title: string;
  subtitle: string;
  size?: 'large' | 'small';
  children: ReactNode;
};

const titleVariant = {
  large: 'title-mid-grey-32',
  small: 'title-small-grey-22',
} as const;

export default function ExpiredSubscriptionContainer({
  title,
  subtitle,
  size = 'large',
  children,
}: ExpiredSubscriptionContainerProps) {
  const titleText =
    size === 'large' ? title : 'This content is for subscribers only';
  return (
    <Container $size={size}>
      <Header>
        <Text variant={titleVariant[size]} color="black">
          {titleText}
        </Text>
        {size === 'large' && (
          <Text
            variant="title-small-grey-22"
            color={Colors.NEUTRAL_VARIANTS[90]}
          >
            {subtitle}
          </Text>
        )}
      </Header>
      {children}
    </Container>
  );
}
